import type { MetaIcon } from "../../constants/icon.constant";
import SolidIconBuilder from "../../helpers/SolidIconBuilder";

interface SecondaryIconProps {
  icon: MetaIcon;
  isActive?: boolean;
}

export default function SecondaryIcon(props: Readonly<SecondaryIconProps>) {
  return SolidIconBuilder({
    icon: props.icon,
    color: props.isActive ? "white" : "gray",
  });
}
